/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Customer_Detail_Plan_ModulesInputs */



/**
* | output |
* | --- |
* | "Plan & modules" |
*
* @param {Partner_Customer_Detail_Plan_ModulesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_customer_detail_plan_modules = /** @type {((inputs?: Partner_Customer_Detail_Plan_ModulesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Customer_Detail_Plan_ModulesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tarif & Module")
	return /** @type {LocalizedString} */ ("Plan & modules")
});